const fixVideoClipStatus = (photo, isVideoClip) => {
  photo.sdVideoStatus = isVideoClip ? photo.sdVideoStatus : undefined
  photo.hdVideoStatus = isVideoClip ? photo.hdVideoStatus : undefined
}

export default fixVideoClipStatus
